export default __webpack_public_path__ + "static/media/Manage money-cuate 1.ca100910.svg";